import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import "./index.scss";

import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import Pagination from "../../../../../components/ui/Pagination";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import CustomTooltip from "../../../../../components/ui/Tooltip";
import RadioButton from "../../../../../components/ui/RadioButton";
import Button from "../../../../../components/ui/Button";

import { searchIcon, filterIcon } from "../../../../../utils/icons";
import { formatDate, formatNumber } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyRiskStats, resetThirdPartyRiskStats, getBotnetLeakList, resetBotnetLeakList } from "../../../../../store/actions/thirdPartyRiskAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const BotnetInfiltrations = () => {

    const botnetLeakStatsResponse = useSelector((state) => state.thirdPartyRisk?.thirdPartyRiskStats);
    const botnetLeaksListResponse = useSelector((state) => state?.thirdPartyRisk?.botnetLeaksList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [botnetLeaksList, setBotnetLeaksList] = useState(null);
    const [scanNotFound, setScanNotFound] = useState(false);

    const [statsLoading, setStatsLoading] = useState(false);
    const [botnetLeaksStats, setBotnetLeakStats] = useState(null);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
        }
        setSelectedFilterValue(obj)
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("")
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchBotnetLeakStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.thirdPartyRisk.compromiseIndicator.botnetLeaks.botnetStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getThirdPartyRiskStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const fetchBotnetLeaksList = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        dispatch(getBotnetLeakList(url))
    },[currentPage, currentPageSize, domainId, organizationId, scanId, searchQuery, selectedFilterValue, dispatch])

    useEffect(()=>{
        fetchBotnetLeaksList()
    },[currentPage, fetchBotnetLeaksList])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchBotnetLeakStats()
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchBotnetLeakStats])

    useEffect(()=>{
        if(botnetLeaksListResponse !== null) {
            setBotnetLeaksList(botnetLeaksListResponse)
            if(botnetLeaksListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }            
            dispatch(resetBotnetLeakList())
            setIsLoading(false)
        }        
    },[botnetLeaksListResponse, dispatch])

    useEffect(()=>{
        if(botnetLeakStatsResponse !== null) {            
            setBotnetLeakStats(botnetLeakStatsResponse)            
            dispatch(resetThirdPartyRiskStats())
            setStatsLoading(false)
        }
    },[botnetLeakStatsResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        }
    },[showFilter])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>                        
                        <Col lg={4}>
                            <div className="discover-doamin-container associated-doamin-page rounded p-3">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"similarDomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                            <div className="header-content d-flex justify-content-between">
                                                <p className="heading">Botnet Leaks</p>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <div className="total-score-container rounded">
                                                    <div className="users-totol-count d-flex">
                                                        <p className="total-score-count">{formatNumber(botnetLeaksStats?.stats?.record_type?.total)}</p>
                                                        <div className="score-count mx-3">
                                                            <span className="new-record d-inline-block mx-1"></span>
                                                            <span className="existing-record d-inline-block"></span>
                                                            <p>Total Botnet Leaks</p>
                                                        </div>
                                                    </div>
                                                    <div className="new-exist-count d-flex gap-5 mt-3">
                                                        <p className="new-record"><span className="d-inline-block">{formatNumber(botnetLeaksStats?.stats?.record_type?.new_record)}</span> New</p>
                                                        <p className="existing-record"><span className="d-inline-block">{formatNumber(botnetLeaksStats?.stats?.record_type?.existing_record)}</span> Existing</p>
                                                    </div>
                                                </div>
                                            </div>
                                    </motion.div>
                                }
                            </div>                            
                        </Col>
                    </Row>
                </div>
                <div className="domain-similarities-container git-leaks-main-content bg-white-with-shadow p-3 mt-3">
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search"
                                    value={searchValue} 
                                    onChange={(e)=>{
                                        setSearchValue(e.target.value)
                                    }}
                                    onFocus={() => setIsSearchFocused(true)}
                                    onBlur={() => setIsSearchFocused(false)}
                                />
                            </div>
                            <button className="search-btn" onClick={onSearch}>Search</button>
                        </div>
                        <div className="position-relative">                                        
                            <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                            <h6>New Findings</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    newFindingsOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={`new-${index}`} isChecked={data.value === newFindingsType} />
                                        )
                                    })
                                }
                            </div>
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === ""} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                            </div>}
                        </div>
                    </div>
                    <div className="table-container js-secrets-table botnet-infiltraion-table mt-4">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"cvesList"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>IP Address</th>
                                        <th>Malware Location</th>
                                        <th>System Name</th>
                                        <th>URL</th>
                                        <th>Username</th>
                                        <th>Browser</th>
                                        <th>Leak Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        botnetLeaksList?.results?.length > 0 &&
                                        botnetLeaksList?.results?.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td>
                                                        {data?.name !== null && data?.name !== "" ? <span className="author-name">{
                                                            data?.name.length > 30 ?
                                                            <CustomTooltip content={data?.name} position={"top"}>
                                                                {data?.name.slice(0, 30) + "..." }
                                                            </CustomTooltip>
                                                            : data?.name
                                                        }</span> : "-"}
                                                        <span className="d-block mt-2 dns-record-domain">{data?.domain}</span>
                                                    </td>
                                                    <td>{data?.ip_address}</td>
                                                    <td>
                                                        {data?.file_location !== null && data?.file_location !== "" ? <span className="author-name">{
                                                            data?.file_location.length > 30 ?
                                                            <CustomTooltip content={data?.file_location} position={"top"}>
                                                                {data?.file_location.slice(0, 30) + "..." }
                                                            </CustomTooltip>
                                                            : data?.file_location
                                                        }</span> : "-"}
                                                    </td>
                                                    <td>{data?.system_name}</td>
                                                    <td className="url-container"><a href={data?.url} target="_blank" className="table-url" rel="noreferrer">{data?.url}</a></td>
                                                    <td>
                                                        <p>{data?.username}</p>
                                                    </td>
                                                    <td>{data?.browser}</td>
                                                    <td>{formatDate(data?.leak_date)}</td>
                                                </motion.tr>
                                            )
                                        })
                                    }                                    
                                </tbody>
                            </Table>
                        }
                        { !isLoading && botnetLeaksList && !scanNotFound && botnetLeaksList?.results?.length > 0 &&
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={botnetLeaksList?.meta?.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />
                        }
                        {
                            !isLoading && !scanNotFound && botnetLeaksList !== "" && botnetLeaksList?.results?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                        {
                            !isLoading && scanNotFound && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={botnetLeaksList?.description}/>
                            </motion.div>
                        }
                    </div>
                </div>                
            </div>
        </>        
    )
}


export default BotnetInfiltrations;